<div>
    <div *ngIf="banner" class="ratio ratio-16x9">
      <iframe [src]="banner | safePipe" class="embed-responsive-item" title="Iframe Example" style="border: 0px; height: 780px !important;"></iframe>
  </div>
</div>